import { setupClient as setupClientAbisko } from '@svt/abtest/client';
import { device } from '@ui-components/breakpoints';
import env from '../app/env';

const error = require('debug')('play:client:abisko:error');
const debug = require('debug')('play:client:abisko:debug');

const DISABLE_ABISKO_KEY = 'DISABLE_ABISKO';

let resolveWaitForAbiskoSetup;
let rejectWaitForAbiskoSetup;

export const waitForAbiskoSetup = new Promise((resolve, reject) => {
    resolveWaitForAbiskoSetup = resolve;
    rejectWaitForAbiskoSetup = reject;
});

// eslint-disable-next-line import/no-mutable-exports
let setupAbisko;

let disableAbisko = false;
const isBrowser = typeof window !== 'undefined';

if (isBrowser) {
    try {
        disableAbisko = Boolean(JSON.parse(window.localStorage.getItem(DISABLE_ABISKO_KEY)) || false);
    } catch (e) {
        disableAbisko = false;
        console.log('error reading local storage', e); // eslint-disable-line
    }
}

if (env.FLAG_ENABLE_ABISKO && !disableAbisko) {
    const isIE11 = isBrowser && Boolean(window.MSInputMethodContext) && Boolean(document.documentMode);
    const hasResizeObserver = isBrowser && window.ResizeObserver !== 'undefined';
    let isMobile = false;
    let isGteLarge = false;
    let isMobileLandscape = false;

    if (isBrowser) {
        const match = window.matchMedia(`${device.GteSmall}`);
        isMobile = !match.matches;
        const landscapeMatch = window.matchMedia(`(orientation: landscape) and (min-height: 600px)`);
        isMobileLandscape = !landscapeMatch.matches;
        const gteLargeMatch = window.matchMedia(device.GteLarge);
        isGteLarge = !gteLargeMatch.matches;
    }

    setupAbisko = (store) =>
        setupClientAbisko({
            projectId: 'svtplay',
            environment: env.ABISKO_ENVIRONMENT,
            networkTimeout: env.ABISKO_CLIENT_TIMEOUT,
            reduxStore: store,
            showDebugInfo: env.IS_DEVELOPMENT,
            clientSideAllocations: true,
            platform: 'web',
            ignoreNewUsers: true,
            experimentsConfig: {
                // Configuration object for specific experiment overrides
                // ['search-grid-experiment']: {
                //     // ignoreNewUsers: true, // If true: Will ignore tests if user has no allocations stored in cookie but will allocate on client
                //     disabled: isIE11,
                // },

                // eslint-disable-next-line no-useless-computed-key
                ['sticky-header']: {
                    ignoreNewUsers: true, // If true: Will ignore tests if user has no allocations stored in cookie but will allocate on client
                    disabled: isIE11 || isMobile || isMobileLandscape,
                },

                'advent-calendar-web': {
                    disabled: isIE11 || isMobile || isMobileLandscape || isGteLarge,
                },

                // eslint-disable-next-line no-useless-computed-key
                ['survey-user-test']: {
                    disabled: isIE11 || isMobile || isMobileLandscape,
                },

                // eslint-disable-next-line no-useless-computed-key
                ['header-content']: {
                    ignoreNewUsers: true, // If true: Will ignore tests if user has no allocations stored in cookie but will allocate on client
                },

                // eslint-disable-next-line no-useless-computed-key
                ['episode-picker']: {
                    disabled: isIE11 || isMobile || isMobileLandscape,
                },

                // eslint-disable-next-line no-useless-computed-key
                ['skip-credits-3']: {
                    disabled: isGteLarge || isIE11 || !hasResizeObserver,
                },

                // eslint-disable-next-line no-useless-computed-key
                ['cookie-consent']: {
                    ignoreNewUsers: false,
                },
            },
        })
            .then(({ projectId, activeExperiments, activeAllocations }) => {
                debug('setupAbiskoClient', {
                    projectId,
                    activeExperiments,
                    activeAllocations,
                });
                resolveWaitForAbiskoSetup && resolveWaitForAbiskoSetup(activeAllocations);
            })
            .catch((e) => {
                error('Got an error from a/bisko', e);
                rejectWaitForAbiskoSetup && rejectWaitForAbiskoSetup();
            });
} else {
    setupAbisko = () => Promise.resolve();
    resolveWaitForAbiskoSetup();
}

export default setupAbisko;
